import isSSR from '../../../utils/isSSR';
import { filterUndefinedAndEmptyValues, getGtmTagValue, gtmEvent } from '../../../utils/gtmEvents';
export const getLinkText = (isInventory, linkText, modelName) => {
    let gtmLinkText = 'contact your dealer';
    if (isInventory) {
        gtmLinkText = (linkText === null || linkText === void 0 ? void 0 : linkText.replace('{model}', modelName || '')) || 'view inventory';
    }
    return gtmLinkText;
};
export const getLinkUrl = (linkUrl, pathName) => linkUrl.indexOf('http') === -1 ? `${pathName}${linkUrl}` : linkUrl;
const gtmLowInventoryWarning = ({ dealerName, linkUrl, componentType, trim, availabilityFlag, bodyStyle, isInventory, linkText, ctaPlacement, }) => {
    var _a, _b, _c, _d;
    const modelName = trim === null || trim === void 0 ? void 0 : trim.modelName;
    const modelKey = trim === null || trim === void 0 ? void 0 : trim.modelKey;
    const pathName = isSSR() ? '' : window.location.origin;
    const gtmLinkText = getLinkText(isInventory, linkText, modelKey);
    const gtmLinkUrl = getLinkUrl(linkUrl, pathName);
    gtmEvent(filterUndefinedAndEmptyValues({
        event: 'bap_trim_cta',
        dealer_name: dealerName,
        cta_type: isInventory ? 'view inventory' : 'contact dealer',
        cta_placement: ctaPlacement || 'trim shortage',
        link_text: gtmLinkText,
        link_url: gtmLinkUrl,
        component_type: componentType,
        model: modelName,
        body_style: bodyStyle || getGtmTagValue((_d = (_c = (_b = (_a = trim === null || trim === void 0 ? void 0 : trim.filters) === null || _a === void 0 ? void 0 : _a.bodyType) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.replace(/<[^>]*>/g, ' ')) === null || _d === void 0 ? void 0 : _d.trim()),
        availablity_flag: availabilityFlag,
    }));
};
export default gtmLowInventoryWarning;
